import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@backslashbuild/pp-ui";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";
import ConsultantForm from "../modules/agencies/ConsultantForm";

export default function EditAgencyContact() {
  const { consultantId } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Edit Consultant</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <ConsultantForm id={consultantId} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
